<template>
  <g>
    <path
      d="M21 12.2202C21 6.73024 16.74 3.00024 12 3.00024C7.31 3.00024 3 6.65024 3 12.2802C2.4 12.6202 2 13.2602 2 14.0002V16.0002C2 17.1002 2.9 18.0002 4 18.0002C4.55 18.0002 5 17.5502 5 17.0002V12.1902C5 8.36024 7.95 5.01024 11.78 4.90024C15.74 4.78024 19 7.96024 19 11.9002V19.0002H12C11.45 19.0002 11 19.4502 11 20.0002C11 20.5502 11.45 21.0002 12 21.0002H19C20.1 21.0002 21 20.1002 21 19.0002V17.7802C21.59 17.4702 22 16.8602 22 16.1402V13.8402C22 13.1402 21.59 12.5302 21 12.2202Z"
    />
    <path
      d="M9 14.0002C9.55228 14.0002 10 13.5525 10 13.0002C10 12.448 9.55228 12.0002 9 12.0002C8.44772 12.0002 8 12.448 8 13.0002C8 13.5525 8.44772 14.0002 9 14.0002Z"
    />
    <path
      d="M15 14.0002C15.5523 14.0002 16 13.5525 16 13.0002C16 12.448 15.5523 12.0002 15 12.0002C14.4477 12.0002 14 12.448 14 13.0002C14 13.5525 14.4477 14.0002 15 14.0002Z"
    />
    <path
      d="M18 11.0302C17.52 8.18024 15.04 6.00024 12.05 6.00024C9.01997 6.00024 5.75997 8.51024 6.01997 12.4502C8.48997 11.4402 10.35 9.24024 10.88 6.56024C12.19 9.19024 14.88 11.0002 18 11.0302Z"
    />
  </g>
</template>
